import { directories, uploadToS3 } from "../../../../utils/S3";
import { triggerBlobDownload } from "../../../../utils/reportExportDownload";

/** Upload the picked file to storage and return its URL (or null). */
export const uploadClientReportFile = async (file, options = {}) => {
  if (!file) return null;
  const ext = String(file.name || "").split(".").pop() || "bin";
  const fileName = `${Date.now()}_client_report.${ext}`;
  const data = await uploadToS3(file, fileName, directories.events, {
    onProgress: options.onProgress,
  });
  return data?.link || null;
};

/** Fetch a stored file and save it to the device under its original name. */
export const downloadClientReportFile = async (url, fileName) => {
  if (!url) throw new Error("Missing client report download url");
  const response = await fetch(url);
  // A failed fetch still resolves — without this the error body is saved as the file.
  if (!response.ok) throw new Error("Client report download failed");
  const blob = await response.blob();
  triggerBlobDownload(blob, fileName);
};

/**
 * Fetch a stored file into an object URL for in-page preview. Going through the
 * same `fetch` the download uses keeps pdf.js off the S3 origin entirely, so
 * range-request CORS quirks can't break the preview. Caller must revoke the URL.
 *
 * `mimeType` re-types the blob when storage answers with a generic
 * `application/octet-stream` — an HTML preview iframe only renders a blob URL
 * whose type is `text/html`.
 */
export const fetchClientReportObjectUrl = async (url, mimeType) => {
  if (!url) throw new Error("Missing client report url");
  const response = await fetch(url);
  if (!response.ok) throw new Error("Client report fetch failed");
  let blob = await response.blob();
  if (mimeType && blob.type !== mimeType) {
    blob = new Blob([blob], { type: mimeType });
  }
  return URL.createObjectURL(blob);
};

/**
 * Registration body for POST .../client_reports.
 * `event_id` and `creator` are server-set — never send them.
 */
export const buildClientReportPayload = (file, uploadUrl) => ({
  name: file?.name,
  size: file?.size,
  content_type: file?.type,
  upload_url: uploadUrl,
});
